import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogArchived } from "@/entities/IProfile";
export default function ProfileActivityLogProfileArchived(t0) {
  const $ = _c(6);
  const {
    log
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-whitespace-nowrap tw-text-base tw-text-iron-300 tw-font-medium">profile</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== log.contents.handle) {
    t2 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{log.contents.handle}</span>;
    $[1] = log.contents.handle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-whitespace-nowrap tw-text-base tw-text-iron-300 tw-font-medium">archived</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <>{t1}{t2}{t3}</>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}